import { userRequest } from '../requestMethods';
import config from '../config';

const DOMAIN = config.REACT_APP_SERVER_DOMAIN;

export const getRapport = async (id_client) => {
    return userRequest.get(`${DOMAIN}/api/rapport?id_client=${id_client}`);
  };

export const getRapportOne = async (id) => {
    return userRequest.get(`${DOMAIN}/api/rapport/one?rapport=${id}`);
  };

export const postRapport = async (data) => {
    return userRequest.post(`${DOMAIN}/api/rapport`, data)
}

//Categorie
export const getCatRapport = async () => {
    return userRequest.get(`${DOMAIN}/api/rapport/cat_rapport`);
  };

//Parametre
export const getParametre = async () => {
    return userRequest.get(`${DOMAIN}/api/rapport/contrat_parametre`);
  };

export const getParametreOne = async (id) => {
    return userRequest.get(`${DOMAIN}/api/rapport/contrat_parametre/one?id_contrat=${id}`);
  };

export const getParametreContratCat = async (id) => {
    return userRequest.get(`${DOMAIN}/api/rapport/contrat_parametreContratCat?id_element_contrat=${id}`);
  };

export const postParametre = async (data) => {
    return userRequest.post(`${DOMAIN}/api/rapport/contrat_parametre`, data)
}

//Element contrat
export const getElementContrat = async () => {
    return userRequest.get(`${DOMAIN}/api/rapport/element_contrat`);
  };

export const getElementContratCat = async (idContrat, idCat) => {
    return userRequest.get(`${DOMAIN}/api/rapport/element_contratCat?id_contrat=${idContrat}&id_cat_rapport=${idCat}`);
  };
export const postElementContrat  = async (data) => {
    return userRequest.post(`${DOMAIN}/api/rapport/element_contrat`, data)
}

//Etiquette
export const getEtiquette = async () => {
    return userRequest.get(`${DOMAIN}/api/rapport/etiquette`);
  };

export const postEtiquette  = async (data) => {
    return userRequest.post(`${DOMAIN}/api/rapport/etiquette`, data)
}

//Contrat
export const getContratRapport = async () => {
    return userRequest.get(`${DOMAIN}/api/rapport/contrat_rapport`);
  };

export const getContratRapportClient = async () => {
    return userRequest.get(`${DOMAIN}/api/rapport/contrat_rapportClient`);
  };

export const getContratRapportClientOne = async (id_client) => {
    return userRequest.get(`${DOMAIN}/api/rapport/contrat_rapportClientOne?id_client=${id_client}`);
  };

export const postContratRapport = async (data) => {
    return userRequest.post(`${DOMAIN}/api/rapport/contrat_rapport`, data)
}

export const getDeclarationTemplate = async (id, idProvince) => {
    return userRequest.get(`${DOMAIN}/api/rapport/declarationTemplate?id_template=${id}&id_province=${idProvince}`);
  };

export const getCloture = async () => {
    return userRequest.get(`${DOMAIN}/api/rapport/cloture`);
  };

export const postCloture = async (data) => {
    return userRequest.post(`${DOMAIN}/api/rapport/cloture`, data)
}

export const postClotureSimple = async (data) => {
    return userRequest.post(`${DOMAIN}/api/rapport/cloture_simple`, data)
}

//Rapport de bon de sortie
export const getRapportBonGlobal = async (startDate, endDate) => {
  return userRequest.get(`${DOMAIN}/api/rapport/rapport_bon_global?startDate=${startDate}&endDate=${endDate}`,);
};

export const getRapportBonPerformance = async (filter) => {
  return userRequest.get(`${DOMAIN}/api/rapport/rapport_performance`,
    {
      params: filter
    });
};

export const getRapportStatutPrincipaux = async (params) => {
  console.log(params)
  return userRequest.get(`${DOMAIN}/api/rapport/rapport_statut_principaux`, { params });
};

export const getRapportIndicateurLog = async (params) => {
  return userRequest.get(`${DOMAIN}/api/rapport/rapport_indicateurs_log`, { params });
};

export const getMouvementVehicule = async (params) => {
  return userRequest.get(`${DOMAIN}/api/rapport/mouvement_vehicule`, { params });
};

//Rapport inspection & Réparation
export const getRapportInspectionRep = async (params) => {
  return userRequest.get(`${DOMAIN}/api/rapport/inspection_rapport_rep`, { params });
};

//Rapport inspection cout
export const getRapportInspectionCout = async (params) => {
  return userRequest.get(`${DOMAIN}/api/rapport/inspection_rapport_cout`, { params });
};

//Rapport inspection cout
export const getRapportPerformanceDelais = async (params) => {
  return userRequest.get(`${DOMAIN}/api/rapport/performance_glo_delais`, { params });
};

//Kiosque
export const getRapportKiosque = async (params) => {
  return userRequest.get(`${DOMAIN}/api/rapport/rapport_kiosque`, { params });
};

//Rapport Charroi vehicule
export const getRapportCharroiVehicule = async (params) => {
  return userRequest.get(`${DOMAIN}/api/rapport/rapport_charroi_vehicule`, { params });
};

export const getRapportUtilitaire = async () => {
  return userRequest.get(`${DOMAIN}/api/rapport/rapport_utilitaire`);
};

export const getFalcon = async () => {
  return userRequest.get('https://apidlog.vps116834.serveur-vps.net/api/falcon'); // toujours en HTTPS car ton site est en HTTPS
};

export const getEvent = async (params) => {
  return userRequest.get("https://apidlog.vps116834.serveur-vps.net/api/get_event", {
    params,
  });
};

export const getEventHistory = async (params) => {
  return userRequest.get("https://apidlog.vps116834.serveur-vps.net/api/get_history", {
    params,
  });
};